import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListAffiliateCouponDefinitionsResponse } from './list-affiliate-coupon-definitions.types'

const listAffiliateCouponDefinitions =
  async (): Promise<ListAffiliateCouponDefinitionsResponse> => {
    const response =
      await apiClient.get<ListAffiliateCouponDefinitionsResponse>(
        '/v1/affiliation/coupon-definitions',
      )
    return response.data
  }

export const useListAffiliateCouponDefinitions = () => {
  return useQuery({
    queryKey: ['affiliate-coupon-definitions'],
    queryFn: () => listAffiliateCouponDefinitions(),
  })
}
